var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.678 4.423L5.834 8.267 3.739 6.18 2.917 7l2.917 2.917L10.5 5.251l-.822-.828zM7 1.168a5.835 5.835 0 00-5.833 5.833A5.835 5.835 0 007 12.835 5.835 5.835 0 0012.834 7 5.836 5.836 0 007 1.168zm0 10.5a4.665 4.665 0 01-4.666-4.667A4.665 4.665 0 017 2.335 4.665 4.665 0 0111.667 7 4.665 4.665 0 017 11.668z",
    fill: "#CACACA"
  })));
}
export default SvgCircleCheck;